import {inject, InjectionToken} from '@node_modules/@angular/core';
import {PreferenciasService} from '@appNeo/neoCore/services/preferencias/preferencias.service';


export const COOKIESTXT = new InjectionToken('Texto Política de Cookies', {
  providedIn: 'root',
    factory: () => {
    const LEGAL_RAZON_SOCIAL =  inject(PreferenciasService).get('legal_razonSocial');
    const NOMBRE_COMERCIAL =  inject(PreferenciasService).get('matrix_nombreComercial');
    const LEGAL_CIF =  inject(PreferenciasService).get('legal_cif');
    const LEGAL_DIRECCION =  inject(PreferenciasService).get('legal_direccion');
    const LEGAL_TELEFONO =  inject(PreferenciasService).get('legal_telefono');
    const LEGAL_EMAIL =  inject(PreferenciasService).get('legal_email');
    const NOMBRE_ABREVIADO =  inject(PreferenciasService).get('matrix_nombreComercialAbreviado');
    const GOOGLE_ANALYTICS_UA = inject(PreferenciasService).get('matrix_googleAnalytics');
    const mercantilTemplate = `<li>Inscrito en el Registro Mercantil de ${inject(PreferenciasService).get('legal_email')}</li>`
    let LEGAL_MERCANTIL;
    inject(PreferenciasService).get('legal_mercantil') ? LEGAL_MERCANTIL = mercantilTemplate : LEGAL_MERCANTIL = '';
    const LEGAL_JUZGADO =  inject(PreferenciasService).get('legal_juzgado');
    let texto = [];
    return texto = [`<h1>Política de cookies</h1>
    <p>Una cookie es un fichero que se descarga en tu equipo al acceder a un sitio web, con el objetivo de almacenar y recuperar información sobre tu navegación. Las cookies no pueden dañar tu equipo.</p>
    <p>Existen varios tipos de cookies:</p>
    <ul>
    <li>Las cookies de sesión caducan al final de tu navegación en el sitio web y permiten al mismo relacionar tus acciones durante esa sesión en particular.</li>
    <li>Las cookies permanentes se almacenan en tu dispositivo entre sesiones, permitiendo al sitio web recordar tus preferencias o acciones en él.</li>
    </ul>
    <p>Dependiendo de su origen:</p>
    <ul>
    <li>Las cookies propias las establece el sitio web que estés visitando.</li>
    <li>Las cookies de terceros las establece un sitio web independiente del que estés visitando.</li>
    </ul>
    <h2>Cookies propias</h2>
    <p>Nuestras cookies son necesarias para el funcionamiento de nuestros servicios, nos ayudan a mejorar nuestro rendimiento y te proporcionan funcionalidades adicionales.</p>
    <div class="duaTable">
    <table>
    <tr>
    <th>Nombre</th>
    <th>Propósito</th>
    <th>Duración</th>
    </tr>
    <tr>
    <td>${NOMBRE_ABREVIADO}_cookie</td>
    <td>Se usa para verificar la aceptación de esta Política de cookies.</td>
    <td>1 año</td>
    </tr>
    <tr>
    <td>${NOMBRE_ABREVIADO}_session</td>
    <td>Se usa para que ciertas características del sitio web funcionen adecuadamente.</td>
    <td>Sesión</td>
    </tr>
    </table>
    </div>' .
    <ng-container *ngIf="${GOOGLE_ANALYTICS_UA}">
      <h2>Cookies de terceros</h2>
      <div class="duaTable">
      <table>
      <tr>
      <th>Origen</th>
      <th>Nombre</th>
      <th>Propósito</th>
      <th>Duración</th>
      </tr>
      <tr>
      <td rowspan="3">Google Analytics</td>
      <td>_ga</td>
      <td>Se usa para distinguir a los usuarios.</td>
      <td>2 años</td>
      </tr>
      <tr>
      <td>_gid</td>
      <td>Se usa para distinguir a los usuarios.</td>
      <td>24 horas</td>
      </tr>
      <tr>
      <td>_gat</td>
      <td>Se usa para limitar el porcentaje de solicitudes.</td>
      <td>1 minuto</td>
      </tr>
      </table>
      </div>') . '
    </ng-container>
    <h2>Desactivación de las cookies</h2>
    <p>Podrás desactivar en cualquier momento las cookies* que desees a través de la configuración de tu navegador**:</p>
    <ul>
    <li><a class="text-underline" href="https://support.google.com/chrome/answer/95647?hl=es" title="" target="_blank" rel="nofollow">Chrome</a></li>
    <li><a class="text-underline" href="https://support.mozilla.org/es/kb/habilitar-y-deshabilitar-cookies-que-los-sitios-we" title="" target="_blank" rel="nofollow">Firefox</a></li>
    <li><a class="text-underline" href="https://support.apple.com/kb/ph5042?locale=es_ES" title="" target="_blank" rel="nofollow">Safari</a></li>
    <li><a class="text-underline" href="http://windows.microsoft.com/es-es/windows7/how-to-manage-cookies-in-internet-explorer-9" title="" target="_blank" rel="nofollow">Explorer</a></li>
    <li><a class="text-underline" href="http://help.opera.com/Windows/11.50/es-ES/cookies.html" title="" target="_blank" rel="nofollow">Opera</a></li>
    </ul>
    <p class="text-p4 text-italic text-right">* Si desactivas estas cookies no podemos garantizar el correcto funcionamiento del sitio web.<br/>** ' . NOMBRE_COMERCIAL . ' no se hace responsable del contenido de los enlaces de esta política de cookies.</p>`];
}
});
